module.exports = __webpack_public_path__ + "static/media/Who_WeAre.8c690c42.svg";